import { Box, Paragraph } from '@zillow/constellation-10';
import { useTourForSatelliteConversationId } from '@zg-rentals/touring';
import AddTourButton from '../AddTourButton';

type NotepadAddTourProps = {
  conversationId: string;
  leadId?: string | null;
  listingAlias: string;
  notedTourStartMs?: number;
};

/** The notepad's "Tour" row, shown only once the lookup confirms the conversation has no tour. */
export default function NotepadAddTour({
  conversationId,
  leadId,
  listingAlias,
  notedTourStartMs,
}: NotepadAddTourProps) {
  const { data: tourData } = useTourForSatelliteConversationId(
    { conversationId, listingAlias },
    { errorDetails: 'NotepadAddTour - Error fetching tour for conversationId' },
  );

  if (!tourData || tourData.tour) return null;

  return (
    <Box css={{ marginBottom: 'loose' }}>
      <Paragraph textStyle="body-bold" css={{ marginBottom: 'default' }}>
        Tour
      </Paragraph>
      {/* oxlint-disable-next-line constellation/no-raw-spacing-values */}
      <Box css={{ inlineSize: '361px', maxInlineSize: '100%' }}>
        <AddTourButton
          conversationId={conversationId}
          leadId={leadId}
          listingAlias={listingAlias}
          notedTourStartMs={notedTourStartMs}
        />
      </Box>
    </Box>
  );
}
